"use client"

import React, { useMemo } from "react"
import cx from "classnames"
import SXOutcomeButton from "@/compositions/OutcomeButton/SXOutcomeButton"

type SxButtonsProps = {
  market: any
  marketName: string
  game: any
  section?: string
  orders: any[]
  isFirstGame?: boolean
}

const SxButtons: React.FC<SxButtonsProps> = ({
  market,
  marketName,
  game,
  orders,
  section,
  isFirstGame = false,
}) => {
  // Check if game has started to determine if buttons should be locked
  const isGameStarted = useMemo(() => {
    if (!orders || orders.length === 0) {
      return false
    }

    const firstOrder = orders[0]
    const gameTime = firstOrder.order?.gameTime

    if (!gameTime) {
      return false
    }

    const gameTimestamp = new Date(gameTime).getTime()
    return gameTimestamp < Date.now()
  }, [orders])
  const isLocked = isGameStarted || !orders || orders.length === 0

  const [betGroup] = game.betGroups

  return (
    <div className="w-full">
      <div
        className={cx(
          "grid gap-x-2 gap-y-3 w-full mt-2 first-of-type:mt-0",
          orders.length === 3 ? "grid-cols-3" : "grid-cols-2"
        )}
      >
        {orders.map((order, orderIndex) => {
          const gameRequiredObj = {
            sportId: game.sport.sportId,
            leagueLabel: game.league.name,
            gameLabel: game.title,
            sportsSlug: game.sport.slug,
            sportsName: game.sport.name,
            betGroup,
            marketType: marketName,
            gameTime: game.startsAt,
            fixtureId: game.gameId,
            providerMarketType: marketName,
            market: order.order.market,
            outcomeOneName: order.order.outcomeOneName,
            outcomeTwoName: order.order.outcomeTwoName,
          }

          return (
            <SXOutcomeButton
              key={order.key}
              marketName={marketName}
              order={order}
              game={gameRequiredObj}
              isLocked={isLocked}
              size={40}
              section={section}
              dataTour={
                isFirstGame && orderIndex === 0 ? "first-game-odds" : undefined
              }
            />
          )
        })}
      </div>
    </div>
  )
}

export const SxMarketSkeleton: React.FC = () => {
  return (
    <div className="w-full mt-2 first-of-type:mt-0">
      <div className="bone w-[110px] h-[0.875rem] ds:mx-auto !block rounded-md mb-[0.375rem]" />
      <div className="grid gap-x-2 gap-y-3 grid-cols-2 w-full">
        <div className="bone w-full h-7 rounded-min" />
        <div className="bone w-full h-7 rounded-min" />
      </div>
    </div>
  )
}

export type SxMarketProps = {
  market: any
  game: any
  section?: string
  marketName?: string
  isFirstGame?: boolean
}

const SxMarket: React.FC<SxMarketProps> = ({
  market,
  game,
  section,
  marketName,
  isFirstGame = false,
}) => {
  return (
    <div className="w-full mt-2 first-of-type:mt-0 ">
      <div className="mb-[0.375rem] mt-auto text-caption-12 font-medium text-accent-grey-200 ds:text-center">
        {marketName}
      </div>
      <SxButtons
        market={market}
        marketName={marketName as string}
        game={game}
        section={section}
        orders={market}
        isFirstGame={isFirstGame}
      />
    </div>
  )
}

export default SxMarket
